import { attr } from '@ember-data/model';
import { computed } from '@ember/object';
import { PAYOUT_ACCOUNT } from './payout-account';
import { getAccountMethodIcon } from '../constants/payout';
import ShModel from './sh-model';

const ACCOUNT_TYPES = {
  HYPERWALLET: 'hyperwallet',
  PAYONEER: 'payoneer',
  CUSTOM: 'custom',
};

const CUSTOM_ACCOUNT_METHODS = {
  CONTACT_SUPPORT: 'contact_support',
};

const CUSTOM_ACCOUNT_METHOD_NAMES = {
  [CUSTOM_ACCOUNT_METHODS.CONTACT_SUPPORT]: 'Contact Support for a payment solution',
};

const HYPERWALLET_ACCOUNT_METHODS = {
  BANK: 'BANK_ACCOUNT',
  PAYPAL: 'PAYPAL_ACCOUNT',
  VENMO: 'VENMO_ACCOUNT',
  WIRE: 'WIRE_ACCOUNT',
};

const HYPERWALLET_ACCOUNT_METHOD_NAMES = {
  [HYPERWALLET_ACCOUNT_METHODS.BANK]: 'Bank transfer',
  [HYPERWALLET_ACCOUNT_METHODS.PAYPAL]: 'PayPal',
  [HYPERWALLET_ACCOUNT_METHODS.VENMO]: 'Venmo',
  [HYPERWALLET_ACCOUNT_METHODS.WIRE]: 'Wire transfer',
};

const PAYONEER_ACCOUNT_METHODS = {
  PAYONEER_CARD: 'payoneer_card',
};

const PAYONEER_ACCOUNT_METHOD_NAMES = {
  [PAYONEER_ACCOUNT_METHODS.PAYONEER_CARD]: 'Payoneer Card',
};

/**
 * @type {Array<String>} The term "class" is used here to denote a combination of "type" and
 * "method" for payout methods. Classes are written in the format <type>:<method>, e.g.
 * "hyperwallet:VENMO_ACCOUNT". This is a list of all the possible combinations, and they are
 * sorted by favorability.
 */
const PAYOUT_METHOD_CLASSES = [
  `${ACCOUNT_TYPES.HYPERWALLET}:${HYPERWALLET_ACCOUNT_METHODS.PAYPAL}`,
  `${ACCOUNT_TYPES.HYPERWALLET}:${HYPERWALLET_ACCOUNT_METHODS.VENMO}`,
  `${ACCOUNT_TYPES.HYPERWALLET}:${HYPERWALLET_ACCOUNT_METHODS.BANK}`,
  `${ACCOUNT_TYPES.HYPERWALLET}:${HYPERWALLET_ACCOUNT_METHODS.WIRE}`,
  `${ACCOUNT_TYPES.PAYONEER}:${PAYONEER_ACCOUNT_METHODS.PAYONEER_CARD}`,
];

export const PAYOUT_METHOD = {
  ACCOUNT_TYPES,
  CUSTOM_ACCOUNT_METHODS,
  CUSTOM_ACCOUNT_METHOD_NAMES,
  HYPERWALLET_ACCOUNT_METHODS,
  HYPERWALLET_ACCOUNT_METHOD_NAMES,
  PAYONEER_ACCOUNT_METHODS,
  PAYONEER_ACCOUNT_METHOD_NAMES,
  PAYOUT_METHOD_CLASSES,
};

const PayoutMethod = ShModel.extend({
  country: attr('string'),
  accountType: attr('string'),
  accountMethod: attr('string'),
  currency: attr('string'),
  detailBullets: attr('object-to-array'),

  /** @type {String} */
  accountMethodName: computed('accountType', 'accountMethod', function () {
    return PAYOUT_ACCOUNT.getAccountTypeText(this.accountType, this.accountMethod);
  }),

  /** @type {String} */
  accountMethodIcon: computed('accountType', 'accountMethod', function () {
    return getAccountMethodIcon(this.get('accountType'), this.get('accountMethod'));
  }),
});

export default PayoutMethod;
